
import axios from "axios";
import atlas from "@/components/atlas.vue";
import noContent from "@/components/noContent.vue";
export default {
  components: { atlas },
  name: "index",
  layout: "DefaultLayout",
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "gallery",

      meta: [
        {
          name: "keywords",
          content: "gallery",
        },
        {
          name: "description",
          content: "users work list",
        },
      ],
    };
  },
  data() {
    return {
      asyncSource: [],
      activeTagId: null,
      tagList: [],
      total: "", //总页数
      pageSize: 20, //每页显示条目个数git
      currentPage: parseInt(this.$route.query.page) || 1, //当前页
      order_type: this.$route.query.order_type || 1, //2最热 1最新
      isAtStart: true,
      isAtEnd: false,
    };
  },
  async asyncData({ $global, query, app, error }) {
    let asyncSource = [];
    let total = 0;
    let tagList = [];
    try {
      const res2 = await $global.worksTag()
      const res = await $global.galleryList({ page: query.page == undefined ? 0 : query.page, class_id: query.class_id == undefined ?  0  : query.class_id })
      if (res.code == 200) {
          asyncSource = res.data.worksList.data
          total = res.data.worksList.total
          tagList = res2.data.tag
      }
    } catch (e) {}
    return { asyncSource, total, tagList };
  },

  mounted() {
    this.activeTagId = this.$route.query.class_id ? this.$route.query.class_id : 0;
    this.updateButtons();
  },
  updated() {
    this.activeTagId = this.$route.query.class_id ? this.$route.query.class_id : 0;
  },
  watchQuery: ["page", "order_type", "class_id", "activeTagId", "currentPage"],
  methods: {
    handleCurrentChange(val) {
      this.$router.push({
        url: "/gallery",
        query: { page: val, class_id: this.activeTagId },
      });
    },
    getTagList(val) {
      this.$router.push({ url: "/gallery", query: { page: 1, class_id: val } });
      this.activeTagId = this.$route.query.class_id ? this.$route.query.class_id : 0;
    },
    scrollToRight() {
      const scrollBox = this.$refs.content;
      this.scrollLeftWithTransition(
        scrollBox,
        scrollBox.scrollWidth - scrollBox.clientWidth,
        500
      );
      this.isAtStart = !this.isAtStart;
      this.isAtEnd = !this.isAtEnd;
    },
    scrollToLeft() {
      const scrollBox = this.$refs.content;
      if (scrollBox.scrollLeft > 0) {
        this.scrollLeftWithTransition(scrollBox, 0, 500);
      }
      this.isAtStart = !this.isAtStart;
      this.isAtEnd = !this.isAtEnd;
    },
    updateButtons() {
      const scrollBox = this.$refs.content;
      this.isAtStart = scrollBox.scrollLeft === 0;
      this.isAtEnd =
        scrollBox.scrollLeft + scrollBox.clientWidth >= scrollBox.scrollWidth;
    },

    scrollLeftWithTransition(element, finalScrollLeft, duration) {
      var start = null;
      var currentScrollLeft = element.scrollLeft;
      var increment = 20; // 每次增加的步长

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        if (progress >= duration) {
          element.scrollLeft = finalScrollLeft;
          return;
        }

        var run = ease(
          progress,
          currentScrollLeft,
          finalScrollLeft - currentScrollLeft,
          duration
        );
        element.scrollLeft = run;

        if (element.scrollLeft !== finalScrollLeft) {
          window.requestAnimationFrame(step);
        }
      }

      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }

      window.requestAnimationFrame(step);
    },
  },
};
